import { render } from "./cta.vue?vue&type=template&id=bd1d208e&ts=true"
import script from "./cta.vue?vue&type=script&lang=ts"
export * from "./cta.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__